<div class="create-template-section">
    <mat-card>
        <mat-card-header>
            <mat-card-title>Create Display Template</mat-card-title>
            <mat-card-subtitle>
                Step 1: create the template metadata for <strong>{{ display.deviceName }}</strong>.
                State layouts and slot images are saved afterward.
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Template Name</mat-label>
                <input matInput [(ngModel)]="templateName" placeholder="e.g. Entry Gate Layout" />
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Layout Mode</mat-label>
                <mat-select [(ngModel)]="templateLayoutMode">
                    @for (mode of layoutModes; track mode) {
                    <mat-option [value]="mode">{{ mode }}</mat-option>
                    }
                </mat-select>
                <mat-hint>Use <strong>SlotBased</strong> for slot authoring and image upload.</mat-hint>
            </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button color="primary" [disabled]="!templateName.trim() || saving" (click)="submit()">
                <mat-icon>add</mat-icon> Create Template
            </button>
        </mat-card-actions>
    </mat-card>
</div>